import { inject, Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { firstValueFrom, Observable, tap } from 'rxjs';
import { Event, eventConverter } from '../models/event.model';
import { AuthService } from './auth.service';
import { doc, docData, Firestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class EventResolverService {
  private firestore = inject(Firestore);

  constructor(
    private afs: AngularFirestore,
    private router: Router,
    private auth: AuthService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<Event | undefined> | Promise<Event> | Event {
    const hasRoles =
      Object.keys(route.data).includes('allowedRoles') &&
      route.data['allowedRoles'].length > 0;

    const eventRef = doc(
      this.firestore,
      `events/${route.paramMap.get('eventId')}`,
    ).withConverter(eventConverter);
    return docData<Event>(eventRef, { idField: 'id' }).pipe(
      tap((event) => {
        firstValueFrom(this.auth.user$).then((user) => {
          if (!event?.name) {
            // Since we are requesting the idField event will never be null.
            this.router.navigate(['/error/404']);
          }
          if (hasRoles && !(user && event && this.auth.canEditEvents(event))) {
            this.router.navigate(['/error/403']);
          }
        });
      }),
    );
  }
}
